import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarComanda } from '../../../actions/comandas';

const EliminarComanda = ({ comanda, reestablecerComanda }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar comanda */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarComanda(comanda?.id));
        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerComanda(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(comanda != null){
            setEliminarModal(true);
        }
    }, [comanda]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar comanda</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar la comanda para "{comanda?.evento?.tipo_evento?.nombre + ' (' + comanda?.evento?.paciente?.nombre + ' - ' + comanda?.evento?.espacio?.nombre + ')" del ' + new Date(comanda?.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + new Date(comanda?.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={statusProcesar}><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ? (
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    ) : (
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                    )
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarComanda;